import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import cx from 'classnames';
import Input from '../../../components/input/Input/Input';
import { PAGE_DEFAULT_TAB_TITLE, PAGE_TAB_TITLE_LIST } from '../../../constants/service/common/pageConstants';
import * as PATHS from '../../../constants/service/common/urlConstants';
import SidebarItem from '../SidebarItem';
import './Sidebar.scss';

const Sidebar = (props) => {
  const { changeCurrent, currentKey, currentPath, sidebar, sidebarItemList, searchKeyword, onSearchMenu } = props;
  const { isCollapsed } = sidebar;

  return (
    <aside className={cx('main-sidebar', { 'is-collapsed': isCollapsed })}>
      <Helmet>
        <title>{PAGE_TAB_TITLE_LIST[PATHS.HOME_URL_PATH]}</title>
      </Helmet>

      <div className="logo-wrap">
        <Link className="logo" to={PATHS.HOME_URL_PATH}>
          {PAGE_DEFAULT_TAB_TITLE}
        </Link>

        <div className="sub-logo">To amondzlab everyone</div>
      </div>

      <div className="search-wrap">
        <Input
          value={searchKeyword}
          onChange={(value) => onSearchMenu(value)}
          maxLength={30}
          placeholder="메뉴를 검색해보세요!!"
          allowClear={true}
        />
      </div>

      <div className="menu-wrap">
        <ul className="menu">
          {sidebarItemList.map((item) => (
            <SidebarItem
              key={item.key}
              id={item.key}
              onClick={() =>
                changeCurrent({
                  currentKey: item.key,
                })
              }
              isCollapsed={isCollapsed}
              icon={item.icon}
              text={item.text}
              active={item.key === currentKey}
              path={item.path}
              currentPath={currentPath}
              subMenu={item.subMenu}
            />
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
